import { useEffect, useState } from 'react';
import * as React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, MenuProps } from 'antd';
import { useStyles } from '@/components/style';


const { Content, Sider } = Layout

const menuItems: MenuProps['items'] = [
  {
    key: '1',
    label: <Link to="/capitalization-template">Captalization Template</Link>,
  },
]

interface FrameProps {
  children: React.ReactNode,
}

interface LevelKeysProps {
  key?: string;
  children?: LevelKeysProps[];
}

const getLevelKeys = (items1: LevelKeysProps[]) => {
  const key: Record<string, number> = {};
  const func = (items2: LevelKeysProps[], level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level;
      }
      if (item.children) {
        func(item.children, level + 1);
      }
    });
  };
  func(items1);
  return key;
};

const levelKeys = getLevelKeys(menuItems as LevelKeysProps[]);

const Frame = (props: FrameProps) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [stateOpenKeys, setStateOpenKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>(['1']);

  const onOpenChange: MenuProps['onOpenChange'] = (openKeys) => {
    const currentOpenKey = openKeys.find((key) => stateOpenKeys.indexOf(key) === -1);
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };

  useEffect(() => {
    const path = location.pathname;
    if (path === '/capitalization-template') {
      setSelectedKeys(['1']);
    }
  }, [location.pathname]);

  useEffect(() => {
    let redirectTo = localStorage.getItem("redirectTo");
    localStorage.removeItem("redirectTo");
    if (!redirectTo) {
      redirectTo = 'capitalization-template'; // default to capitalization template
    }
    switch (redirectTo) {
      case 'capitalization-template':
        navigate('/capitalization-template');
        onOpenChange([]);
        setSelectedKeys(['1']);
        break;
      default:
        navigate('/capitalization-template');
        onOpenChange([]);
    }
  }, []);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout>
        {/* Sidebar */}
        <Sider
          width={180}
          theme='dark'
          style={{
            position: 'fixed',
            height: '100vh',
            left: 0,
            top: 0,
            bottom: 0,
            overflow: 'auto',
            zIndex: 1000,
          }}
          className="site-layout-background"
        >
          <div style={{ height: '100%', borderRight: 0 }}>
            <div className={styles.center} style={{ padding: '20px' }}>
              <img src={"assets/AlphaScript-logo.png"} alt="Alpha Script Logo" style={{ width: '70%' }} />
            </div>
            <Menu
              theme='dark'
              mode="inline"
              openKeys={stateOpenKeys}
              onOpenChange={onOpenChange}
              selectedKeys={selectedKeys}
              style={{ borderRight: 0 }}
              items={menuItems}
              className={styles.menuStyles}
            />
          </div>
        </Sider>

        {/* Content Area */}
        <Layout style={{ padding: '0 24px 24px', marginLeft: 180, width: 'calc(100%-180px)' }}>
          {/* Main Content */}
          <Content
            className="site-layout-background"
            style={{
              padding: 0,
              margin: 0,
              minHeight: 280,
            }}
          >
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}

export default Frame;
